import React from 'react';

const TeamInline = props => (
  <div>
    {props.team.map(person => (
      <div>
        <h3>{person.title}</h3>
        <p>
          <strong>{person.desc}</strong>
        </p>
        {person.people.map(single => (
          <div className="col-md-6 float-left" key={single.slug}>
            <div className="single-partner single-testimonal">
              <div className="media">
                <a href={`/equipe/${single.slug}`}>
                  <img src={single.photo} alt={single.name} className="col-md-8" />
                </a>
                <div className="media-body">
                  <a href={`/equipe/${single.slug}`}>{single.name}</a>
                  <h3>{single.function}</h3>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default TeamInline;



// WEBPACK FOOTER //
// ./src/components/TeamInlineFR.js